module.exports = __webpack_public_path__ + "media/application/images/2018/star-grey-807291c64df85b72d7506a974ccb10b0.svg";